import MuiStack, { StackProps as MuiStackProps } from '@mui/material/Stack';

export const Stack = (props: MuiStackProps): JSX.Element => {
  return <MuiStack {...props} />;
};

export default Stack;
